import { ReactNode } from 'react';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';

export const ReCaptchaContext = ({ children, reCaptchaKey }: { children: ReactNode; reCaptchaKey: string }): JSX.Element => {
  if (reCaptchaKey) {
    return <GoogleReCaptchaProvider reCaptchaKey={reCaptchaKey}>{children}</GoogleReCaptchaProvider>;
  }
  return <>{children}</>;
};
